import React, { ChangeEvent } from "react";
import { FormControl, TextField, Typography } from "@mui/material";
import InputErrors from "./InputErrors";

export interface IFormTextFieldProps {
  label: string;
  name: string;
  value: string;
  placeholder: string;
  errors?: string[];
  onChange: (_value: string) => void;
  autoFocus?: boolean;
  disabled?: boolean;
  type?: string;
  endAdornment?: React.ReactNode;
  className?: string;
}

const FormTextField: React.FC<IFormTextFieldProps> = ({
  label,
  name,
  value,
  placeholder,
  errors = [],
  onChange,
  autoFocus = false,
  disabled = false,
  type = "text",
  endAdornment,
  className = "m-t-20",
}) => (
  <FormControl className={className} fullWidth>
    <Typography className="f-s-14 m-b-10">{label}</Typography>
    <TextField
      fullWidth
      size="small"
      name={name}
      type={type}
      placeholder={placeholder}
      value={value}
      error={errors.length > 0}
      onChange={(e: ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
      autoFocus={autoFocus}
      disabled={disabled}
      InputProps={{ endAdornment }}
    />
    {errors.length > 0 && <InputErrors errors={errors} />}
  </FormControl>
);

export default FormTextField;
